import Vue from 'vue';
import { AxiosError, AxiosResponse } from 'axios';

import * as Mutations from './mutations.type'
import { Question } from './types';


// генератор сеттеров
const setter = (field, subfield?: string) => {
  if (subfield) {
    return (commit, state, data) => {
      commit('common/SET_SUBITEM', { 
        state,
        field,
        subfield,
        data
      }, {root: true})
    }
  }
  return (commit, state, data) => {
    commit('common/SET_ITEM', { 
      state,
      field,
      data
    }, {root: true})
  }
}

const setTest = setter('activeTest')
const setMembersList = setter('courseMembers')
const setAllProgress = setter('userProgress')
const updLessonProgress = setter('userProgress', 'lessons')
const setTestProgress = setter('activeTest', 'progress')

// Добавление задачи в панель доски
export const getAdmins = async ({commit}: any, client_id: string) => { 
  const response:AxiosResponse = await Vue.axios.get(`api/clients/${client_id}/settings/admins/lms`)
  // изменение текущего трека
  commit(Mutations.SET_ADMINS, response.data || [])
}

// Добавление задачи в панель доски
export const setAdmins = async ({commit}: any, data: {client_id: string, admins: string[]}) => { 
  const response:AxiosResponse = await Vue.axios.put(`api/clients/${data.client_id}/settings/admins/lms`, data.admins)
  // изменение текущего трека
  commit(Mutations.SET_ADMINS, response.data || [])
}

export const getMembers = async ({commit, rootState}: any, course_id: string) => { 
  const response:AxiosResponse = await Vue.axios.get(`api/courses/${course_id}/members`)
  // изменение текущего трека
  setMembersList(commit, rootState.courses, response.data.result)
}

export const setMembers = async ({commit, rootState}: any, data: {course_id: string, empl: string}) => { 
  const response:AxiosResponse = await Vue.axios.post(`api/courses/${data.course_id}/members`, { empl: data.empl})
  // добавление участников
  setMembersList(commit, rootState.courses, response.data.result)
}

export const addQuestion = async ({commit, rootState}: any, data: {test_id: string, question: Question}) => { 
  const response:AxiosResponse = await Vue.axios.post(`api/tests/${data.test_id}/questions`, { question: data.question })
  // добавление участников в
  setTest(commit, rootState.courses, response.data.result)
}

export const editQuestion = async ({commit, rootState}: any, data: {test_id: string, question: Question}) => { 
  const response:AxiosResponse = await Vue.axios.put(`api/tests/${data.test_id}/questions`, { question: data.question })
  // добавление участников в 
  setTest(commit, rootState.courses, response.data.result)
}

export const deleteQuestion = async ({commit, rootState}: any, data: {test_id: string, question_id: string}) => { 
  const response:AxiosResponse = await Vue.axios.delete(`api/tests/${data.test_id}/questions/${data.question_id}`)
  // добавление участников в 
  setTest(commit, rootState.courses, response.data.result)
}

// Работа с тестами = старт, ответ, завершение
export const startTest = async ({commit, rootState}: any, data: {course_id: string, test_id: string, user_id: string}) => { 
  const response:AxiosResponse = await Vue.axios.post(`api/tests/${data.course_id}/startTest/${data.test_id}/for/${data.user_id}`)
  // добавление участников в 
  setTestProgress(commit, rootState.courses, response.data.result)
}

type SendingAnswer = {
  course_id: string,
  test_id: string, 
  user_id: string, 
  question: string,
  answer: string,
}

export const sendAnswer = async ({commit, rootState}: any, data: SendingAnswer) => { 
  const response:AxiosResponse = await Vue.axios.post(`api/tests/${data.test_id}/answer`, data)
  // добавление участников в 
  setTestProgress(commit, rootState.courses, response.data.result)
}

// export const endTest = async ({commit, rootState}: any, data: {test_id: string, user_id: string}) => { 
//   const response:AxiosResponse = await Vue.axios.post(`api/tests/${data.test_id}/endFor/${data.user_id}`)
//   // добавление участников в 
//   setProgress(commit, rootState.courses, response.data.result)
// }

// Получение аналитики - либо общей по клиенту (общий дашборд) либо по конкретному сотруднику
type GetAnalyticReq = {
  client_id: string,  // если задано только оно, то получаем по всем сотрудникам
  user_id?: string,   // если задано, то для конкретного пользователя детальная информация
}
export const getAnalytic = async ({commit, rootState}: any, data: GetAnalyticReq) => { 
  const response:AxiosResponse = await Vue.axios.get(`api/courses/analytics/${data.client_id}`, {params: {user_id: data.user_id}})
  // добавление участников в 
  commit('common/SET_ITEM', { 
      state: rootState.courses,
      field: data.user_id ? 'analyticsUserData' : 'analyticsData', // одно поле для всех типов аналитик - либо общая либо по конкретному пользователю
      data: response.data.result
    }, {root: true})
}

// Получение статистики по одному тесту для вкладки "Участники"
export const getTestStatistic = async ({commit, rootState}: any, data: {client_id: string, test_id: string}) =>{ 
  const response:AxiosResponse = await Vue.axios.get(`api/tests/${data.test_id}/stat`)
  // добавление участников в 
  commit('common/SET_ITEM', { 
      state: rootState.courses,
      field: 'testStatisticData', // одно поле для всех типов аналитик - либо общая либо по конкретному пользователю
      data: response.data.result
    }, {root: true})
}

export const getLessonStatistic = async ({commit, rootState}: any, lesson_id: string) =>{
  const response:AxiosResponse = await Vue.axios.get(`api/lessons/${lesson_id}/stat`)
  // добавление участников в 
  commit('common/SET_ITEM', { 
      state: rootState.courses,
      field: 'lessonStatisticData', // одно поле для всех типов аналитик - либо общая либо по конкретному пользователю
      data: response.data.result
    }, {root: true})
}

// Получение прогресса по курсу для конкретного пользователя и курса
export const getUserProgress = async ({commit, rootState}: any, data: {course_id: string, user_id: string}) => {
  const response:AxiosResponse = await Vue.axios.get(`api/course_progress/progress/${data.course_id}/${data.user_id}`)
  // добавление участников в 
  setAllProgress(commit, rootState.courses, response.data.result)
}

export const learnLesson = async ({commit, rootState}: any, data: {course_id: string, user_id: string, lesson_id: string}) => {
  const response:AxiosResponse = await Vue.axios.put(`api/course_progress/learn`, data)
  // добавление участников в 
  updLessonProgress(commit, rootState.courses, response.data.result)
}

export const getDashboardData = async ({commit, rootState}: any, client_id: string) => {
  const response:AxiosResponse = await Vue.axios.get(`api/course_progress/${client_id}/dashboard`)
  // добавление участников в 
  commit('common/SET_ITEM', { 
      state: rootState.courses,
      field: 'dashboardData', // одно поле для всех типов аналитик - либо общая либо по конкретному пользователю
      data: response.data.result
    }, {root: true})
}